<template>
  <ul class="submenu">
    <slot></slot>
  </ul>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class SubMenu extends Vue {}
</script>

<style lang="scss">
ul.submenu {
  cursor: auto;
  background: #e0e0e0;
  background: linear-gradient(180deg, #f0f0f0 0%, #e0e0e0 100%);
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 0;
  margin: 0;
  list-style: none;
  min-width: 150px;
}
</style>
